import { render } from "./ReferenceReport.vue?vue&type=template&id=8bb8ff68&scoped=true&ts=true"
import script from "./ReferenceReport.vue?vue&type=script&lang=ts"
export * from "./ReferenceReport.vue?vue&type=script&lang=ts"

import "./ReferenceReport.vue?vue&type=style&index=0&id=8bb8ff68&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb8ff68"]])

export default __exports__